import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, isEqual} from "lodash"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {PERIOD_VALUE_PROPERTY} from "@irati-web/fields/schedule"
import {Radio} from "@irati/ui/src/FormItem"

export const PROPERTY = "preferences.emails.userReminder.afterDays"

class AfterDays extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    label: PropTypes.string,
    name: PropTypes.string
  }

  static defaultProps = {
    name: PROPERTY,
    label: `insights.fields.schedule.${PROPERTY}.label`
  }
  constructor(props) {
    super(props)
    this.state = {
      options: this.getOptions(this.determineAfterDaysValue())
    }
  }

  getOptions = (afterDaysValue) => {
    const {formatMessage} = this.props
    return [
      {label: formatMessage({id: `insights.fields.schedule.${PROPERTY}.option0.label`}), value: 0},
      {label: formatMessage({id: `insights.fields.schedule.${PROPERTY}.option${afterDaysValue}.label`}), value: afterDaysValue}
    ]
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.schedule, prevProps.schedule)) {
      this.updateOptions()
    }
  }

  updateOptions = () => {
    this.setState({
      options: this.getOptions(this.determineAfterDaysValue())
    })
  }

  handleChange = (afterDaysValue) => {
    const {onChange, schedule, name} = this.props
    onChange(schedule, name, afterDaysValue)
  }

  determineAfterDaysValue = () => {
    const {schedule} = this.props
    const selectedFrequency = get(schedule, PERIOD_VALUE_PROPERTY)

    switch (selectedFrequency) {
      case 2:
        return 7
      case 4:
        return 14
      default:
        return 3
    }
  }

  render() {
    const idNamespace = id("AfterDays", this.props)
    const {schedule, name, label, formatMessage} = this.props
    const afterDaysValue = schedule.preferences.emails.userReminder.afterDays
    const {options} = this.state
    const radioLabel = formatMessage({id: label})

    return (
      <>
        <Radio
          label={radioLabel}
          name={name}
          id={id("radio", idNamespace)}
          onChange={this.handleChange}
          options={options}
          value={afterDaysValue} />
      </>
    )
  }
}

export default injectIntl(AfterDays)
